import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import Root from '../Root';

const renderStartupError = (error: unknown) => {
  const container = document.getElementById('root');
  if (!container) return;
  const message = error instanceof Error ? error.message : String(error);
  container.innerHTML = `
    <div role="alert" style="padding:2rem;color:#7f1d1d;background:#fef2f2;font-family:system-ui,sans-serif">
      <h1>Failed to start The Third Door</h1>
      <p>${message}</p>
    </div>
  `;
};

try {
  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root mount element');
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <Root />
    </StrictMode>
  );
} catch (error) {
  renderStartupError(error);
}
